/* Details work without JS. This adds dismissal and responsive focus recovery. */
if (!customElements.get('delufe-header')) {
  customElements.define('delufe-header', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const close = (details, restoreFocus = false) => {
        details.open = false;
        if (restoreFocus) details.querySelector('summary').focus();
      };
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        const details = event.target.closest('details[open]');
        if (details && this.contains(details)) {
          event.preventDefault();
          event.stopPropagation();
          close(details, true);
        }
      }, { signal });
      document.addEventListener('click', (event) => {
        this.querySelectorAll('details[open]').forEach((details) => {
          if (!details.contains(event.target)) close(details);
        });
      }, { signal });
      this.addEventListener('focusout', (event) => {
        // activeElement can temporarily be body between blur and focus.
        // relatedTarget identifies the actual destination without that race.
        if (!event.relatedTarget) return;
        this.querySelectorAll('details[open]').forEach((details) => {
          if (!details.contains(event.relatedTarget)) close(details);
        });
      }, { signal });
      document.addEventListener('focusin', (event) => { this.lastFocused = event.target; }, { signal });
      document.addEventListener('pointerdown', () => { this.lastFocused = null; }, { signal });
      const desktop = matchMedia('(min-width: 68.75rem)');
      desktop.addEventListener('change', () => {
        const hiddenNav = this.querySelector(desktop.matches ? '.site-header__mobile' : '.site-header__desktop');
        if (hiddenNav?.contains(document.activeElement) || (document.activeElement === document.body && hiddenNav?.contains(this.lastFocused))) {
          const destination = this.querySelector(desktop.matches ? '.site-header__brand' : '.site-header__toggle');
          destination?.focus();
        }
        this.querySelectorAll('details[open]').forEach((details) => close(details));
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
